module.exports = __webpack_public_path__ + "static/media/cribl-dark-mode.899b3ab2.svg";